import { Box, Paper, Tab, Tabs } from '@material-ui/core';
import React, { FC, useMemo, useState } from 'react';
import ReactPlayer from 'react-player';
import { YouTube } from '@material-ui/icons';

import Dialog from '../common/modals/dialog';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Video: FC = () => {
  const [value, setValue] = useState(window.isNativeApp ? -1 : 0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const playerUrl = useMemo(() => {
    return [
      'https://youtu.be/UPjPb-y0IuQ',
      'https://youtu.be/oTdeq_opfnw',
      'https://youtu.be/Pz5sJ-1fNOA',
      // 'https://youtu.be/JteCi0FVRHw',
    ][value];
  }, [value]);

  if (window.isNativeApp) {
    return (
      <>
        <Paper>
          <Box px={1} py={1} style={{ fontSize: 16 }}>
            <Box
              display="flex"
              alignItems="center"
              my={1}
              onClick={() => setValue(0)}
            >
              <YouTube color="secondary" />
              Установка на iOS
            </Box>
            <Box
              display="flex"
              alignItems="center"
              my={1}
              onClick={() => setValue(1)}
            >
              <YouTube color="secondary" />
              Сканирование ХО
            </Box>
            <Box
              display="flex"
              alignItems="center"
              my={1}
              onClick={() => setValue(2)}
            >
              <YouTube color="secondary" />
              Заведение новых клиентов в СНЕГ
            </Box>
            {/*<Box display={'flex'} alignItems={'center'} my={1} onClick={() => setValue(3)} >*/}
            {/*  <YouTube color={'secondary'} />Инвентаризация ХО*/}
            {/*</Box>*/}
          </Box>
        </Paper>
        <Dialog open={value !== -1} title="Видео" onClose={() => setValue(-1)}>
          <Box width="100%">
            <ReactPlayer
              width="100%"
              height={465}
              url={playerUrl}
              stopOnUnmount
              controls
            />
          </Box>
        </Dialog>
      </>
    );
  }

  return (
    <Box height="100%" display="grid">
      <Paper>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Установка на iOS" {...a11yProps(0)} />
          <Tab label="Сканирование ХО" {...a11yProps(1)} />
          <Tab label="Заведение новых клиентов в СНЕГ" {...a11yProps(2)} />
          {/*<Tab label="Инвентаризация ХО" {...a11yProps(3)} />*/}
        </Tabs>
        <Box width="100%">
          <ReactPlayer
            width="100%"
            height={465}
            url={playerUrl}
            stopOnUnmount
            controls
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default Video;
